import { createAction } from "redux-actions";

// fetch all AgentRecommendations
export const FETCH_AGENT_RECOMMENDATIONS = "FETCH_AGENT_RECOMMENDATIONS";
export const fetchAgentRecommendations = createAction(FETCH_AGENT_RECOMMENDATIONS);

export const FETCH_AGENT_RECOMMENDATIONS_REQUESTED = "FETCH_AGENT_RECOMMENDATIONS_REQUESTED";
export const fetchAgentRecommendationsRequested = createAction(FETCH_AGENT_RECOMMENDATIONS_REQUESTED);

export const FETCH_AGENT_RECOMMENDATIONS_FAILURE = "FETCH_AGENT_RECOMMENDATIONS_FAILURE";
export const fetchAgentRecommendationsFailure = createAction(FETCH_AGENT_RECOMMENDATIONS_FAILURE);

export const FETCH_AGENT_RECOMMENDATIONS_SUCCESS = "FETCH_AGENT_RECOMMENDATIONS_SUCCESS";
export const fetchAgentRecommendationsSuccess = createAction(FETCH_AGENT_RECOMMENDATIONS_SUCCESS);

// unlock AgentRecommendations level
export const UPDATE_AGENT_RECOMMENDATIONS = "UPDATE_AGENT_RECOMMENDATIONS";
export const updateAgentRecommendations = createAction(UPDATE_AGENT_RECOMMENDATIONS);

export const UPDATE_AGENT_RECOMMENDATIONS_REQUESTED = "UPDATE_AGENT_RECOMMENDATIONS_REQUESTED";
export const updateAgentRecommendationsRequested = createAction(UPDATE_AGENT_RECOMMENDATIONS_REQUESTED);

export const UPDATE_AGENT_RECOMMENDATIONS_FAILURE = "UPDATE_AGENT_RECOMMENDATIONS_FAILURE";
export const updateAgentRecommendationsFailure = createAction(UPDATE_AGENT_RECOMMENDATIONS_FAILURE);

export const UPDATE_AGENT_RECOMMENDATIONS_SUCCESS = "UPDATE_AGENT_RECOMMENDATIONS_SUCCESS";
export const updateAgentRecommendationsSuccess = createAction(UPDATE_AGENT_RECOMMENDATIONS_SUCCESS);
